import { mitigationDryingSettingRegistrations } from './mitigation-drying-setting-definitions.js';
import { mitigationDryingReportDataSettingRegistrations } from './mitigation-drying-report-data-setting-definitions.js';
import { mitigationFieldCompletionSettingRegistrations } from './mitigation-field-completion-setting-definitions.js';
import { mitigationMoistureEvidenceSettingRegistrations } from './mitigation-moisture-evidence-setting-definitions.js';
import { mitigationPsychrometricsSettingRegistrations } from './mitigation-psychrometrics-setting-definitions.js';
import { mitigationContentsSettingRegistrations } from './mitigation-contents-inventory-setting-definitions.js';
export const mitigationSettingRegistrations = [
    ...mitigationMoistureEvidenceSettingRegistrations,
    ...mitigationDryingSettingRegistrations,
    ...mitigationDryingReportDataSettingRegistrations,
    ...mitigationFieldCompletionSettingRegistrations,
    ...mitigationPsychrometricsSettingRegistrations,
    ...mitigationContentsSettingRegistrations,
];
//# sourceMappingURL=mitigation-setting-catalog.js.map